import type { AxisRenderer } from "../xy/axes/AxisRenderer";
import type { GanttDateAxisRenderer } from "./GanttDateAxisRenderer";
import type { Gantt } from "./Gantt";

import { DateAxis, IDateAxisSettings, IDateAxisPrivate, IDateAxisDataItem, IDateAxisEvents } from "../xy/axes/DateAxis";

export interface IGanttDateAxisSettings<R extends AxisRenderer> extends IDateAxisSettings<R> {
}

export interface IGanttDateAxisDataItem extends IDateAxisDataItem {
	/**
	 * `true` once the user has marked this date by clicking the lower date
	 * axis. Its grid line is then hidden, so only the mark shows.
	 */
	active?: boolean;
}

export interface IGanttDateAxisPrivate extends IDateAxisPrivate {
}

export interface IGanttDateAxisEvents extends IDateAxisEvents {
}


/**
 * A date axis of a [[Gantt]] chart. The Gantt has two, both above the plot
 * area: `xAxis` with the larger time units and `xAxisMinor` below it.
 *
 * @see {@link https://docs.amcharts.com/v5/charts/gantt/#timeline-horizontal-axis} for more info
 * @since 5.14.0
 * @important
 */
export class GanttDateAxis<R extends GanttDateAxisRenderer> extends DateAxis<R> {
	public static className: string = "GanttDateAxis";
	public static classNames: Array<string> = DateAxis.classNames.concat([GanttDateAxis.className]);

	declare public _settings: IGanttDateAxisSettings<R>;
	declare public _privateSettings: IGanttDateAxisPrivate;
	declare public _dataItemSettings: IGanttDateAxisDataItem;
	declare public _events: IGanttDateAxisEvents;

	/**
	 * A reference to the parent [[Gantt]] chart.
	 */
	public gantt?: Gantt;
}
